<template>
  <div data-testid="interior-area-form">
    <div v-if="!value.type">
      <div
        class="flex items-center justify-between bg-cream px-2 sm:px-5 py-3 rounded-t-sm"
      >
        <h3 class="font-semibold">What is your area?</h3>
        <button
          type="button"
          class="focus:outline-none"
          @click="$emit('delete', index)"
        >
          <span class="sr-only">Remove</span>
          <div class="w-3 h-3">
            <IconCrossSmall />
          </div>
        </button>
      </div>
      <div
        class="grid grid-cols-2 gap-x-4 gap-y-2 items-center px-2 sm:px-5 py-5 rounded-b-sm bg-cream bg-opacity-50"
      >
        <label
          class="col-span-2 sm:col-span-1"
          :for="`area-type-select-${index}`"
          >What size is the room?</label
        >
        <div class="col-span-2 sm:col-span-1">
          <SelectMenu
            :id="`area-type-select-${index}`"
            v-model="areaTypeValue"
            test-id="area-type-select"
            :options="areaTypeOptions"
            placeholder="Choose..."
          >
          </SelectMenu>
        </div>
      </div>
    </div>
    <component
      :is="formComponent()"
      v-else
      :index="index"
      :value="value"
      :label="formLabel()"
      @input="(area) => $emit('input', area)"
      @delete="$emit('delete', index)"
    />
  </div>
</template>

<script>
import config from "../config";
import RoomForm from "./RoomForm.vue";
import WallForm from "./WallForm.vue";
import IconCrossSmall from "../../../../templates/_includes/svg/icon-cross-small.svg";
import SelectMenu from "../../ui/SelectMenu.vue";

export default {
  name: "InteriorAreaForm",

  components: { IconCrossSmall, SelectMenu },

  props: {
    index: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      areaTypeValue: "Choose...",
      config,
    };
  },

  computed: {
    areaTypeOptions() {
      return Object.values(this.config.areas.INTERIOR_AREA_TYPES).map(
        (value) => {
          return {
            value,
            label: this.config.areas.INTERIOR_AREA_OPTION_LABELS[value],
          };
        }
      );
    },
  },

  watch: {
    areaTypeValue(value) {
      this.$emit("input", {
        ...this.config.areas.INTERIOR_AREA_DEFAULTS[value],
        id: this.value.id,
      });
    },
  },

  methods: {
    formComponent() {
      return this.config.areas.INTERIOR_AREA_ROOM_TYPES.includes(
        this.value.type
      )
        ? RoomForm
        : WallForm;
    },

    formLabel() {
      return this.config.areas.INTERIOR_AREA_OPTION_LABELS[this.value.type];
    },
  },
};
</script>
